import * as React from "react";
import {
  Card,
  CardBody,
  TabStrip,
  TabStripTab,
} from "@progress/kendo-react-layout";
import ProductFeature from "../../../ProductFeature/Pages/ProductFeature";
import { isComponentUpdate } from "smart-react";

/**
 * Test Details Desktop view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The DesktopView component.
 */
const DesktopView = ({
  selected,
  handleSelect,
  detailsDataModified,
  state,
}) => {
  const [product, setProduct] = React.useState(state.dataSet);
  React.useEffect(() => {
    setProduct(state.dataSet);
  }, [state]);
  return (
    <>
      <Card>
        <TabStrip
          className="page-tabs"
          selected={selected}
          onSelect={handleSelect}
        >
          <TabStripTab
            title="Features"
            contentClassName={`tabs-card ${
              detailsDataModified === true ? "tab-modified" : ""
            }`}
          >
            <Card
              className={`tabs-card ${
                detailsDataModified === true ? "tab-modified" : ""
              }`}
            >
              <CardBody>
                <div className="card-body">
                  <ProductFeature product={product} />
                </div>
              </CardBody>
            </Card>
          </TabStripTab>
        </TabStrip>
      </Card>
    </>
  );
};

// Export the memoized component
export default React.memo(DesktopView, isComponentUpdate);
